
import { Action             } from "@/models/action";
import { ActionType         } from "@/models/action.type";
import { Logger             } from "@/util/logger";
import { PanoramaController } from "@/components/panorama.controller";

export class PanoUnlockApplication extends Action {

  /** how much to turn by */
  public _delta = 10.0;

  /** the panoramic controller that can actually do stuff for us */
  private _controller : PanoramaController = null;

  /** standard constructor */
  constructor(controller : PanoramaController) {
    super({
      key:   ActionType.PANO_UNLOCK_APPLICATION,
      type:  ActionType.PANO_UNLOCK_APPLICATION,
      label: 'Unlock Navigation',
      icon:  '',
      tip:   ''
    });

    this._controller = controller;
  }

  /** fetch the panoramic controller */
  public controller(): PanoramaController {

    return this._controller;
  }

  /** implement the action */
  public execute() : boolean {

    this._controller.unlock();

    return true;
  }
}
